import React from 'react';
import checkIcon from '../../../../Icons/icon-feature-check.svg';
import { cardObj } from './Data';

const FeatureCards = () => {
  return (
    <div className="card-container">
      {cardObj.map((obj: any, index: number) => {
        return (
          <div
            className={`right-img-card font-black bg-161616 h-2/5 rounded-3xl mt-12 p-9 flex sticky top-12  mobile:flex-col `}
            style={{
              transform: `translateY(${index * 0.75}rem) `,
            }}
            key={obj.title}
          >
            <div
              className={
                obj.index % 2 === 0
                  ? 'text-container w-1/2 flex flex-col align-middle justify-center pl-16 mobile:pl-4 mobile:w-full order-2 mobile:order-none '
                  : 'text-container w-1/2  flex flex-col align-middle justify-center pl-16 mobile:pl-4 mobile:w-full'
              }
            >
              <div className="text-heading text-5xl mobile:text-2xl font-medium	leading-11 tracking-tighter font-manrope ">
                {obj.title}
                <br />
                <p className="opacity-48 text-white">
                  {obj.subtitle}
                </p>
              </div>
              <ul className="feature-list mt-5 font-manrope font-normal text-sm leading-6 tracking-wide text-white mobile:pb-10">
                {obj.features.map((featurePoint: string) => {
                  return (
                    <li className="flex" key={featurePoint}>
                      <img src={checkIcon} loading="lazy" alt="" />
                      <p className="opacity-60 pl-3">
                        {featurePoint}
                      </p>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="image-left w-1/2 mobile:w-full mobile:overflow-hidden">
              <img
                src={obj.image}
                loading="lazy"
                alt=""
                className="h-full w-full "
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeatureCards;
